import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface InternalNoteDialogData {
  notes?: string;
}

@Component({
  selector: 'app-internal-note-dialog',
  templateUrl: './internal-note-dialog.component.html',
  styleUrls: ['./internal-note-dialog.component.css'],
})
export class InternalNoteDialogComponent {
  note = '';

  constructor(
    public dialogRef: MatDialogRef<InternalNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InternalNoteDialogData
  ) {
    this.note = String(data?.notes || '');
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.note);
  }
}
